module.exports = __webpack_public_path__ + "static/03-66f527192b1fc66f15e711f940cf229b.png";